import { createContext, useContext } from "react";
import { URL_API } from "../config/default";
import { myHeaders } from "../config/axios";
import { useQuery } from "@tanstack/react-query";

// Crear el contexto
const AppContext = createContext({} as any);

export const AppProvider = ({ children }: any) => {

  const { data: banners } = useQuery({
    queryKey: ["public-banners"],
    queryFn: () => {
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);
      const params = new URLSearchParams({ status: 'activo' });

      return fetch(`${URL_API}/banners?${params}`, {
        method: "GET",
        headers: {
          Authorization: myHeaders,
        },
      }).then((res) => res.json());
    },
  });

  const { data } = useQuery({
    queryKey: ["me"],
    queryFn: () => {
      const token = localStorage.getItem("token");
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);
      if (token) {
        return fetch(`${URL_API}/auth/me`, {
          method: "GET",
          headers: {
            Authorization: myHeaders,
          },
        }).then((res) => {
          if (!res.ok) {
            localStorage.removeItem("token");
            throw new Error("Error en la API");
          }
          return res.json();
        })
      }

      return null
    },
  });

  return <AppContext.Provider value={{ me: data?.data ?? null, banners: banners?.data ?? [], }}>{children}</AppContext.Provider>;
};

// Hook para consumir el contexto fácilmente
export const useAppContext = () => {
  return useContext(AppContext);
};
